"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var serviceWorker = _interopRequireWildcard(require("./service-worker"));
var localStorage = _interopRequireWildcard(require("./local-storage"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * @module browser
 * 
 * This module groups various browser-related utilities and APIs
 * such as service workers, localStorage, cookies, etc.
 * 
 * It provides a single namespace `browser` to access these functionalities,
 * keeping browser-specific logic organized and encapsulated.
 * 
 * Example usage:
 * ```ts
 * import browser from './browser'
 * 
 * browser.serviceWorker.register()
 * ```
 */

const browser = {
  serviceWorker,
  localStorage
};
var _default = exports.default = browser;